import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import { Controller, useForm } from "react-hook-form";
import { useSuperAdminSuscripts } from "../../../context/SuperAdmin/SuscriptsContext";
import { Estado } from "../../../interfaces/SuperAdmin/Others/iDataEstado";
import { PostSuscriptFields } from "../../../interfaces/SuperAdmin/Pages/iDataSuscripcion";

const CreateSuscriptModal = () => {
  const {
    isCreateModalOpen,
    toggleCreateModal,
    isCreating,
    planes,
    isLoadingPlans,
    selectedOrg,
    createSuscription,
  } = useSuperAdminSuscripts();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm<PostSuscriptFields>({});

  const fechaInicio = watch("fecha_inicio");
  const isToday = fechaInicio === new Date().toISOString().split("T")[0];

  const handleFechaChange = (newDate: string) => {
    setValue("fecha_inicio", newDate);
    if (!newDate || newDate !== new Date().toISOString().split("T")[0]) {
      setValue("estado", Estado.INACTIVO);
    }
  };

  const handleSubmitForm = (data: PostSuscriptFields) => {
    console.log(data);
    createSuscription(data);
  };

  const handleClose = () => {
    if (!isCreating) {
      reset();
      toggleCreateModal(false);
    }
  };

  return (
    <Modal
      open={isCreateModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)",
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        {isLoadingPlans ? (
          <Typography
            id="edit-subscription-modal-title"
            justifyContent={"center"}
            sx={{
              width: 1,
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Cargando...
          </Typography>
        ) : (
          <>
            <Typography variant="h6" component="h2">
              Nueva suscripción
            </Typography>

            <Controller
              name="id_organizacion"
              control={control}
              defaultValue={selectedOrg}
              render={({ field }) => <input type="hidden" {...field} />}
            />

            {/* Campo Tipo plan */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Planes
              </Typography>
              <FormControl error={!!errors.id_plan}>
                <Controller
                  name="id_plan"
                  control={control}
                  rules={{ required: "El tipo de plan es obligatorio" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      value={field.value || ""}
                      fullWidth
                      disabled={isCreating}
                    >
                      {planes.map((plan) => (
                        <MenuItem key={plan.id_plan} value={plan.id_plan}>
                          {plan.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText>{errors.id_plan?.message}</FormHelperText>
              </FormControl>
            </Box>

            {/* Campo de fecha de inicio */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Fecha de inicio
              </Typography>
              <Controller
                name="fecha_inicio"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="date"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: new Date().toISOString().split("T")[0],
                    }}
                    sx={{ minWidth: "100%", mt: 1 }}
                    onChange={(e) => handleFechaChange(e.target.value)}
                  />
                )}
              />
            </Box>

            {/* Switch para id_estado */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Estado
              </Typography>
              <FormControlLabel
                control={
                  <Controller
                    name="estado"
                    control={control}
                    render={({ field }) => (
                      <Switch
                        {...field}
                        checked={field.value === Estado.ACTIVO}
                        onChange={(e) =>
                          setValue(
                            "estado",
                            e.target.checked ? Estado.ACTIVO : Estado.INACTIVO
                          )
                        }
                        disabled={!isToday}
                      />
                    )}
                  />
                }
                label=""
              />
            </Box>

            <Box sx={{ mt: 3, textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ background: "#336B87" }}
                disabled={isCreating}
                type="submit"
              >
                Crear
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default CreateSuscriptModal;
